<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <toggle :value="allowWrapping" @input="onInput" />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

export default {
    name: 'flex-wrap',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Content Wrapping',
            tailwindDefinitionProp: 'flexWrap',
            allowWrapping: false,
            message: '* this will allow content to flow to the next row, if the width of the content exceeds the width of the container',
        };
    },

    watch: {
        changedOption({ option, value }) {
            if (option === 'flex-direction') this.onConflict('flex-direction', value);
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(allowWrapping) {
            const flexClassNew = this.addFlexClass({
                value: allowWrapping ? 'wrap' : 'no-wrap',
            });

            this.allowWrapping = allowWrapping;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.allowWrapping = this.flexClassDefinition.value === 'wrap';
        },

        onConflict(option, value) {
            switch (option) {
                case 'flex-direction':
                    if (value === 'col' || value === 'col-reverse') {
                        this.addFlexClass({ value: 'no-wrap' });
                        this.allowWrapping = false;
                    } else {
                        this.addFlexClass({ value: 'wrap' });
                        this.allowWrapping = true;
                    }

                    break;

                default:
                    // do nothing
            }
        },
    },
};
</script>
